import { Box, Link, Typography } from "@mui/material";
import type * as React from "react";
import { COLOGUARD_WEBSITE_URL } from "./constants";

const footnoteSx = {
  m: 0,
  typography: "body_sm_dark_gray"
} as const;

const publicPolicyLinkSx = {
  color: "inherit",
  textDecoration: "underline",
  textUnderlineOffset: "2px"
} as const;

const DisclaimerSection: React.FC = () => (
  <Box
    component="section"
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 2,
      width: "100%"
    }}
  >
    <Typography component="p" sx={footnoteSx}>
      Cologuard is a registered trademark of the Abbott group of companies. All
      rights reserved.
    </Typography>
    <Typography component="p" sx={footnoteSx}>
      Genomic Life offers navigation support when members get colon cancer
      screening, including Cologuard. Unlike DNA screenings included in the
      Genomic Life membership, colon cancer screening would be billed to your
      primary insurance by the test provider, as it is generally covered by
      existing health benefits for people between age 45 and 75.
    </Typography>
    <Typography component="p" sx={footnoteSx}>
      * Cologuard products are intended to screen adults 45 and older at average
      risk for colorectal cancer. Cologuard is available by prescription only. 
    </Typography>
    <Typography component="p" sx={footnoteSx}>
      † False negative and false positive results can occur. A false negative
      result means the test did not find signals of cancer, but a person does
      have cancer. A false positive result means the test found signals of
      cancer, but a person doesn’t have cancer.
    </Typography>
    <Typography component="p" sx={footnoteSx}>
      ‡ Your individual benefits may differ. Exact Sciences estimate based on
      historical patient billing. Rate of coverage varies by state and region.
      Exceptions for coverage may apply; only your health insurer can confirm
      how Cologuard would be covered. See the{" "}
      <Link
        href={COLOGUARD_WEBSITE_URL}
        rel="noopener noreferrer"
        sx={publicPolicyLinkSx}
        target="_blank"
      >
        Cologuard website
      </Link>{" "}
      to learn more.
    </Typography>
    <Typography component="p" sx={footnoteSx}>
      Reference: 1. American Cancer Society. Colorectal Cancer Is A Major Public
      Health Problem. Last updated: August 5, 2025. Accessed July 30, 2026 at:{" "}
      <Link
        href="https://nccrt.org/our-impact/data-and-progress"
        rel="noopener noreferrer"
        sx={publicPolicyLinkSx}
        target="_blank"
      >
        nccrt.org/our-impact/data-and-progress
      </Link>
      .
    </Typography>
  </Box>
);

export default DisclaimerSection;
